// src/services/tokens.ts
import { API_BASE_URL } from "@/services";
import type { TokenMetadata, TokenMetadataResponse } from "@/types/tokens";

export async function fetchTokens(signal?: AbortSignal): Promise<TokenMetadata[]> {
  const url = `${API_BASE_URL}/tokens`;
  const init: RequestInit = signal ? { signal } : {};
  const res = await fetch(url, init);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const json = (await res.json()) as TokenMetadataResponse;
  return json.data;
}


